/*
 *  Copyright (c) Qwoach LLC 2023. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 16/11/2023
 */

import AccessRuleItem from "@shared/Profile/AccessRuleItem.js";
import {RoleEnum} from "@shared/Permissions/RoleEnum.js";
import {ClearanceLevelEnum} from "@shared/Profile/ClearanceLevelEnum.js";

export default class ClientAccessRuleItem extends AccessRuleItem {

	constructor() {
		super([RoleEnum.CLIENT], {}, ClearanceLevelEnum.ALL);
	}
}
